/**
 * Frases aleatorias para mostrar cuando se envía una solicitud de replay
 * Estilo mexicano/deportivo - 50 frases de 5-7 palabras
 */

export const replayPhrases = [
  "Se acaba de ir un jugadón",
  "Luces, cámara, acción",
  "¡Qué buen video, eeh!",
  "Buenísimo, en un momento lo tienes",
  "Se manda a producción, vamos",
  "Buena jugada, los felicito",
  "¡Así era, muchachooooos!",
  "Así nomás quedó",
  "¡Eso estuvo de lujo!",
  "¡Para el recuerdo, papá!",
  "¡Qué jugadota se marcaron!",
  "Directo al hall de la fama",
  "¡Eso merece repetición instantánea!",
  "La cámara no miente, crack",
  "¡Se viene el videoazo!",
  "Preparando tu mejor momento",
  "¡Qué manera de jugar!",
  "Esto va para los highlights",
  "¡Se rifaron con esa!",
  "Capturando la magia del juego",
  "¡Tremenda jugada, compadre!",
  "Eso sí fue de antología",
  "¡Ya estuvo el videito!",
  "Momento épico en camino",
  "¡Esa jugada estuvo mortal!",
  "Guardando tu obra maestra",
  "¡Qué golazo de replay!",
  "Procesando pura calidad",
  "¡Eso fue legendario!",
  "En corto lo tienes listo",
  "¡Qué nivel, carnal!",
  "Momento histórico capturado",
  "¡Se la rifaron, equipo!",
  "Enviando a producción ya",
  "¡Puro talento en video!",
  "Esa jugada va al museo",
  "¡Qué espectáculo, maestro!",
  "Inmortalizado para siempre",
  "¡Así se juega, crack!",
  "Tu replay viene en camino",
  "¡Momento de gloria capturado!",
  "Eso estuvo increíble, va",
  "¡Para presumir después!",
  "Guardando el momentazo",
  "¡Qué manera de brillar!",
  "Esto se va viral seguro",
  "¡Pura magia en la cancha!",
  "Capturando la chulada",
  "¡Eso estuvo de diez!",
  "¡Ya merito lo tienes!"
];

/**
 * Obtiene una frase aleatoria del array
 * @returns {string} Una frase aleatoria
 */
export const getRandomPhrase = () => {
  const index = Math.floor(Math.random() * replayPhrases.length);
  return replayPhrases[index];
};
